import AppConstants from './app.constants';
import flat from 'flat';
import languages from '../language';

let LanguageLoaderService = function ($http, $q, MessageService, User, LanguageService, $translate, ConfigService, Modal, Configs, UsersService, Idle) {

  const DEFAULT_LANGUAGE = 'E';

  return (options) => {
    console.log(`fetch language ${options.key}`)

    return ConfigService.getConfig()
      .then((data) => {
        const pageTitle = data.config.pageTitle;
        const companyName = data.config.companyName;
        const printFromLocationName = data.config.printFromLocationName;
        const printFromLocationAddress = data.config.printFromLocationAddress;
        Configs.setEnvironmentConfig(data.config.environmentConfig);
        document.getElementById('pageTitle').innerHTML = pageTitle;

        if (data.config.environmentConfig && data.config.environmentConfig.sessionLength > 0) {
          localStorage.setItem('sessionLength', JSON.stringify(data.config.environmentConfig.sessionLength));
          if (User.getUser() && User.isSignedIn()) {
            Idle.watch();
            Idle.setIdle(data.config.environmentConfig.sessionLength * 60);
          }
        } else {
          localStorage.removeItem('sessionLength');
          Idle.unwatch();
        }

        if (User.getUser()) {
          const defer = $q.defer();

          $q.all([
            LanguageService.getAllUIMessages(options.key),
            UsersService.validateUserPermissions(User.getUser().firstName, User.getUser().lastName)
          ])
            .then((details) => {
              const messages = details[0];
              const permissions = details[1];
              Configs.setPermissionConfig(permissions);

              if (!messages || !messages.length) {
                defer.resolve();
                return $translate.use(DEFAULT_LANGUAGE);
              }

              if (!messages || !messages.length) {
                defer.resolve();
                return $translate.use(DEFAULT_LANGUAGE);
              }

              const translation = {};

              messages.forEach((message) => {
                translation[message.messageId] = message.description;
              });

              return flat.unflatten(translation);
            })
            .then((translationObj) => {
              translationObj['common']['app_name'] = companyName;
              translationObj['bagout_print']['fromLocationName'] = printFromLocationName;
              translationObj['shipmentBatch']['fromLocationName'] = printFromLocationName;
              translationObj['bagout_print']['fromLocationAddress'] = printFromLocationAddress;
              defer.resolve(translationObj);
            })
            .catch((err) => {
              defer.reject(err);
              $translate.use(DEFAULT_LANGUAGE);
            });

          return defer.promise;
        }
        else {
          return $q.when(languages[options.key] || languages[DEFAULT_LANGUAGE]);
        }
      })
      .catch((err) => {
        Modal.errorModal(err.data.message);
      })
  };
};

LanguageLoaderService.$inject = ['$http', '$q', 'MessageService', 'User', 'LanguageService', '$translate', 'ConfigService', 'Modal', 'Configs', 'UsersService', 'Idle']

export default LanguageLoaderService;


// WEBPACK FOOTER //
// ./client/app/config/language-loader.service.js